import { Box, BoxProps, ColorOptions, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { convertHexToRGBA } from '@jfs/ui-new/src/utils/utils'
import { useNavigation } from '@react-navigation/native'
import { SvgImage } from '../../comps/SvgImage'
import { useStores } from '../../data/store'
import { getCategoryMetaData, TransactionStatus } from '../../util/billPaymentUtil'
import { Colors } from '../../util/util'

import { RenderHeader } from './RenderHeader'

const RenderItems = ({ item, index, handlePress }: any) => {
  return (
    <Box
      key={index}
      testID={'billpay-title-' + item?.name?.replaceAll(' ', '')}
      onPress={() => handlePress(item)}
      underlayColor={'TRANSPARENT'}
      {...styles.myBillsCardViewWrapper}>
      <Box width={72} {...styles.card}>
        <Box {...styles.iconContainer}>
          <SvgImage color={Colors.SECONDARY} imageName={item.iconId} />
        </Box>
        <SpacerNew size={8} direction="vertical" />
        <Text
          ellipsizeMode={'tail'}
          // wordBreak={'break-all'}
          fontFamily="JioType-Medium"
          lineHeight={16}
          textAlign="center"
          fontSize={12}
          numberOfLines={3}
          color={'BLACK'}>
          {item?.name}
        </Text>
      </Box>
    </Box>
  )
}

const FinancialServices = ({ data, title }: any) => {
  const navigation = useNavigation()

  const { updateCategorySelection } = useStores((root) => ({
    updateCategorySelection: root.billPayments?.updateCategorySelection,
  }))

  if (!data?.length) {
    return null
  }

  const handlePress = (selected) => {
    const catId = selected?.id
    updateCategorySelection({ catId, status: TransactionStatus.INITIATED })
    const navDetail = getCategoryMetaData(catId)
    const screenName = navDetail.operatorScreen
    navigation.navigate(screenName as never, { title: navDetail.title, screenDetails: navDetail } as never)
  }

  return (
    <ModBox show={data?.length}>
      <Box ph={24}>
        <RenderHeader title={title} />
      </Box>
      <SpacerNew size={20} direction="vertical" />

      <Box flexDirection={'row'} justifyContent="flex-start" flexWrap={'wrap'}>
        {data?.map((item: any, index: number) => (
          <RenderItems key={index} item={item} index={`${item.icon}-${index}`} handlePress={handlePress} />
        ))}
      </Box>

      {/* <FlatList
        data={data}
        horizontal={false}
        numColumns={4}
        contentContainerStyle={styles.contentContainer}
        showsHorizontalScrollIndicator={false}
        renderItem={({ item, index }) => <RenderItems item={item} index={index} handlePress={handlePress} />}
        ListEmptyComponent={renderEmpty}
        keyExtractor={keyExtractorData}
        extraData={data}
      /> */}
    </ModBox>
  )
}

export { FinancialServices }

const styles = {
  myBillsCardViewWrapper: {
    align: 'center',
    width: '25%',
    justify: 'flex-start',
    mb: 24,
  } as BoxProps,
  contentContainer: { flexGrow: 1 },
  card: {
    alignItems: 'center',
  } as BoxProps,
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 50,
    height: 50,
    borderRadius: 50,
    backgroundColor: convertHexToRGBA(Colors.SECONDARY, 8) as ColorOptions,
  } as BoxProps,
}
